module.exports = __webpack_public_path__ + "img/drink_responsibly.45e10922.svg";